import React from "react";

const MapInfo = ({ showInfo, context }) => {
  if (!showInfo) return null;

  return (
    <div className="home-detailHeader" >
      <div
        className="home-detailHeader-body"
        style={{ textAlign: "center" }}
      >
        <div></div>
        <div>
          <b className="mobile-noDisplay littleDesktop-noDisplay">
            Última actualización:{" "}
          </b>
          {context.lastUpdate}
        </div>
        <div></div>
      </div>
      {
        context.selectedLoteamiento ? (
          <div>
            <div className="home-detailHeader-title">
              {context.selectedLoteamiento.properties.name}
            </div>
            <div className="home-detailHeader-body">
              <div>
                <b className="mobile-noDisplay littleDesktop-noDisplay">
                  Ciudad:
                  </b>{" "}
                {
                  context.selectedLoteamiento.properties.developments
                    .features[0].properties.district.name
                }
              </div>
              <div>
                <b className="mobile-noDisplay littleDesktop-noDisplay">
                  Departamento:
                  </b>{" "}
                {
                  context.selectedLoteamiento.properties.developments
                    .features[0].properties.district.department.name
                }
              </div>
              <div>
                <b className="mobile-noDisplay littleDesktop-noDisplay">
                  Lotes Disponibles:{" "}
                </b>
                {context.selectedLoteamiento.available_parcels} /{" "}
                {context.selectedLoteamiento.total_parcels}
                <span className="bigDesktop-noDisplay"> lotes</span>
              </div>
            </div>
          </div>
        ) : (
            <div style={{ lineHeight: "50px" }}>
              Seleccione una fracción en el mapa
            </div>
          )
      }
    </div >
  )
};

export default MapInfo;
